import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort } from '@/utils'

const state = () => ({})
const getters = {}

const mutations = {}

const actions = {
  PostGet(context, params) {
    return request({
      url: api.PostGet,
      method: 'GET',
      params,
    })
  },
  PostDelete(context, params) {
    return request({
      url: api.PostDelete,
      method: 'DELETE',
      params,
    })
  },

  PostPublish(context, params) {
    return request({
      url: api.PostPublish,
      method: 'POST',
      data: params,
    })
  },

  PostUpdate(context, params) {
    return request({
      url: api.PostUpdate,
      method: 'PATCH',
      data: params,
    })
  },

  TopicTagGetList(context, params) {
    return request({
      url: api.TopicTagGetList,
      method: 'POST',
      data: params,
    })
  },

  PostSelectMyPost(context, params) {
    return request({
      url: api.PostSelectMyPost,
      method: 'GET',
      params,
    })
  },

  PostSelectByTenant(context, params) {
    return request({
      url: api.PostSelectByTenant,
      method: 'GET',
      params,
    })
  },
  PostSelectByTopic(context, params) {
    return request({
      url: api.PostSelectByTopic,
      method: 'GET',
      params,
    })
  },
  PostSelectByAuthor(context, params) {
    return request({
      url: api.PostSelectByAuthor,
      method: 'GET',
      params,
    })
  },
  TopicTagGetByIds(context, params) {
    return request({
      url: api.TopicTagGetByIds,
      method: 'POST',
      data: params,
    })
  },
  PostSearch(context, params) {
    return request({
      url: api.PostSearch,
      method: 'GET',
      params,
    })
  },
  GetBatchArticleStatistics(context, params) {
    return request({
      url: api.GetBatchArticleStatistics,
      method: 'POST',
      data: params,
    })
  },
  ArticleOperationCancel(context, params) {
    return request({
      url: api.ArticleOperationCancel,
      method: 'POST',
      data: params,
    })
  },
  PostSelectByIdList(context, params) {
    return request({
      url: api.PostSelectByIdList,
      method: 'POST',
      data: params,
    })
  },
  /// <summary>
  // /// 浏览
  // /// </summary>
  // Browse = 1,

  // /// <summary>
  // /// 评论
  // /// </summary>
  // Comment = 2,

  // /// <summary>
  // /// 点赞
  // /// </summary>
  // Praise = 3,

  // /// <summary>
  // /// 转发
  // /// </summary>
  // Share = 4,

  // /// <summary>
  // /// 检索
  // /// </summary>
  // Retrieval = 5,

  // /// <summary>
  // /// 收藏
  // /// </summary>
  // Collect = 6
  ArticleOperationIncrease(context, params) {
    return request({
      url: api.ArticleOperationIncrease,
      method: 'POST',
      data: params,
    })
  },
  GetArticlesByAction(context, params) {
    return request({
      url: api.GetArticlesByAction,
      method: 'POST',
      data: params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
